import { Pagination } from '@/constants/pagination';
import { PaginationAPI } from '@/types/pagination';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type CashbackState = {
    accrual: CashbackAccrual | null;
    transactions: CashbackTransaction[];
    transactionsPagination: PaginationAPI;
    loading: boolean;
    dataCashback: CashbackType | null;
};

export const cashbackInitialState: CashbackState = {
    accrual: null,
    transactions: [],
    transactionsPagination: {
        Page: Pagination.Page,
        totalPages: 0,
        totalElements: 0,
        Size: Pagination.Size,
    },
    loading: false,
    dataCashback: null
};

const slice = createSlice({
    name: 'cashback',
    initialState: cashbackInitialState,
    reducers: {
        setCashbackDetailAction(
            state,
            {
                payload,
            }: PayloadAction<{
                accrual: CashbackAccrual;
                transactions: CashbackTransaction[];
                pagination?: PaginationAPI;
                append?: boolean;
            }>,
        ) {
            state.accrual = payload.accrual;

            if (payload.append) {
                state.transactions = [...state.transactions, ...payload.transactions];
            } else {
                state.transactions = payload.transactions;
            }

            state.transactionsPagination = payload.pagination || state.transactionsPagination;
        },

        setCashbackLoading(state, action: PayloadAction<boolean>) {
            state.loading = action.payload;
        },

        clearCashbackDetailAction(state) {
            state.accrual = null;
            state.transactions = [];
            state.transactionsPagination = {
                Page: Pagination.Page,
                totalPages: 0,
                totalElements: 0,
                Size: Pagination.Size,
            };
        },

        setListCashbackAction(state, actions: PayloadAction<{ data: CashbackType }>) {
            const { payload } = actions;

            state.dataCashback = payload.data;
        },
    },
});

export const {
    setCashbackDetailAction,
    setCashbackLoading,
    clearCashbackDetailAction,
    setListCashbackAction
} = slice.actions;

export default slice.reducer;
